// Contas das despesas: IVA e retorno do investimento.
import { r2 } from "./ComRec";
const num = (v) => Number(v || 0);

export const TAXAS_IVA = [0, 6, 13, 23];

// O valor sem IVA e a taxa mandam; o IVA e o total saem sempre daí.
export function calcularIva(semIva, taxa) {
  const base = r2(num(semIva)), t = num(taxa);
  const iva = r2(base * t / 100);
  return { valor_sem_iva: base, taxa_iva: t, valor_iva: iva, valor_total: r2(base + iva) };
}

// Retorno = o que a agência recebeu menos o que gastou (sem IVA, porque o IVA recupera-se).
export function retorno(gastoSemIva, recebido) {
  const g = r2(gastoSemIva), rec = r2(recebido), ret = r2(rec - g);
  return { gasto: g, recebido: rec, retorno: ret, pct: g > 0 ? r2(ret / g * 100) : null };
}

// Agrupa despesas por uma chave e junta o que foi recebido nessa mesma chave (quando faz sentido)
export function agrupar(despesas, chave, recebidoPor = {}) {
  const m = new Map();
  despesas.forEach((d) => {
    const k = chave(d) || "Sem indicação";
    const t = m.get(k) || { chave: k, n: 0, semIva: 0, comIva: 0 };
    t.n += 1; t.semIva += num(d.valor_sem_iva); t.comIva += num(d.valor_total); m.set(k, t);
  });
  return [...m.values()].map((t) => {
    const rec = recebidoPor[t.chave];
    return { ...t, semIva: r2(t.semIva), comIva: r2(t.comIva), recebido: rec == null ? null : r2(rec), ...(rec == null ? {} : retorno(t.semIva, rec)) };
  }).sort((a, b) => b.semIva - a.semIva);
}
